import './card-config.component.scss';
import {IComponentController} from "angular";

export class CardConfigComponent implements IComponentController {

    static directive: angular.IDirectiveFactory = () => ({
        template: require('./card-config.component.html'),
        controller: [CardConfigComponent],
        transclude: {
            configs: 'configs'
        }, scope: {
            title: '<',
            iconUrl: '<',
        }
    });

    private title: string;
    private iconUrl: string;
}